export enum FilterValueType {
    DISCRETE,
    RANGE,
}
